import type { AxiosResponse } from 'axios';
import axiosInstance from './axiosInstance';
import type {
  AdminDTO,
  RecallEmailListReq,
  RecallEmailSaveOrUpdateReq,
  ResponseDTOBoolean,
  ResponseDTOPageQueryResultRecallEmailIListResp,
  ResponseDTORecallEmailIListResp,
} from '@/types/recall';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const test = async (
  params: RecallEmailSaveOrUpdateReq
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/recallEmail/test`,
    params
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const saveOrUpdate = async (
  params: RecallEmailSaveOrUpdateReq & AdminDTO
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/recallEmail/saveOrUpdate`,
    params
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const listCustom = async (
  params: RecallEmailListReq
): Promise<AxiosResponse<ResponseDTOPageQueryResultRecallEmailIListResp>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/recallEmail/list`,
    params
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const cancel = async (
  params: AdminDTO
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/recallEmail/cancel?userId=${params.userId}&name=${params.name}&avatarUrl=${params.avatarUrl}&avatarBig=${params.avatarBig}&avatarMiddle=${params.avatarMiddle}&avatarThumb=${params.avatarThumb}`,
    params
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*}
 * @returns
 */
export const recallPublish = async (): Promise<
  AxiosResponse<ResponseDTOBoolean>
> => {
  const response = await axiosInstance.get(
    `${baseUrl}/recallEmail/recallPublish`
  );

  return response;
};

/**
 * 请补充描述...
 * @param {*} params
 * @returns
 */
export const getDetail2 = async (params: {
  recallEmailId: number;
}): Promise<AxiosResponse<ResponseDTORecallEmailIListResp>> => {
  const response = await axiosInstance.get(`${baseUrl}/recallEmail/detail`, {
    params,
  });

  return response;
};
